// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Title(Props) {
  var text = Props.text;
  var ext_classOpt = Props.ext_class;
  var ext_class = ext_classOpt !== undefined ? ext_classOpt : "";
  return React.createElement("div", {
              className: "flex w-full text-size-h1 py-2 font-heading " + ext_class
            }, text);
}

var make = Title;

export {
  make ,
  
}
/* react Not a pure module */
